/* eslint-disable no-console */

import {
  register
} from 'register-service-worker'

register(`${process.env.BASE_URL}service-worker.js`, {
  ready () {
    console.log('Service worker is active.')
  },
  registered () {
    console.log('Service worker has been registered.')
  },
  cached () {
    console.log('Content has been cached for offline use.')
  },
  updatefound () {
    console.log('New content is downloading.')
  },
  updated () {
    console.log('New content is available; please refresh.')
    caches.keys().then(cacheNames => {
      return Promise.all(
        cacheNames.map(cacheName => {
          return caches.delete(cacheName)
        })
      )
    })
  },
  offline () {
    console.log(
      'No internet connection found. App is running in offline mode.'
    )
  },
  error (error) {
    console.log('Error during service worker registration:', error)
  }
})
